import React from 'react';
import { List, ListItem, ListItemText, withStyles } from '@material-ui/core';
import { TutorialesListElement } from './TutorialesListElement';

const TutorialesList_ = (props) => {
  let { tutoriales, classes } = props;

  const renderizarTutoriales = () => {
    if (tutoriales && tutoriales.length > 0) {
      return tutoriales.map((tutorial, index) => {
        return (
          <TutorialesListElement
            tutorial={tutorial}
            tutoriales={tutoriales}
            index={index}
            key={index}
          />
        );
      });
    } else {
      return (
        <ListItem>
          <ListItemText primary="No hay tutoriales disponibles en esta sección" />
        </ListItem>
      );
    }
  };

  return <List classes={{ root: classes.list }}>{renderizarTutoriales()}</List>;
};

const styles = (theme) => ({
  list: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    padding: '0',
    '&:last-child': {
      borderBottom: '0px solid transparent',
    },
  },
});

export const TutorialesList = withStyles(styles, { withTheme: true })(
  TutorialesList_
);
